module.exports = __webpack_public_path__ + "static/img/Moderate_Snow.50099c69.png";